import Axios from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

export const GetSubCategoryList = (data) => {
  return Axios({ role: ROLE.ADVERTISER }).post("advertiser/product-subcategories/list", { per_page: 1000, ...data })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
